(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[716],{

/***/ 7026:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ph": function() { return /* binding */ Select; }
/* harmony export */ });
/* unused harmony exports DefaultIcon, SelectField */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
/* harmony import */ var _chakra_ui_form_control__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(3234);
/* harmony import */ var _chakra_ui_system__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5235);
/* harmony import */ var _chakra_ui_system__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4520);
/* harmony import */ var _chakra_ui_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2446);
/* harmony import */ var _chakra_ui_utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(8554);
/* harmony import */ var _chakra_ui_utils__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_chakra_ui_utils__WEBPACK_IMPORTED_MODULE_5__);
// ../../react-shim.js


// src/select.tsx




var SelectField = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_1__/* .forwardRef */ .Gp)(function SelectField2(props, ref) {
  const { children, placeholder, className, ...rest } = props;
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_chakra_ui_system__WEBPACK_IMPORTED_MODULE_1__/* .chakra.select */ .m$.select, {
    ...rest,
    ref,
    className: (0,_chakra_ui_utils__WEBPACK_IMPORTED_MODULE_2__.cx)("chakra-select", className)
  }, placeholder && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("option", {
    value: ""
  }, placeholder), children);
});
if (_chakra_ui_utils__WEBPACK_IMPORTED_MODULE_2__/* .__DEV__ */ .Ts) {
  SelectField.displayName = "SelectField";
}
var Select = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_1__/* .forwardRef */ .Gp)((props, ref) => {
  const styles = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_1__/* .useMultiStyleConfig */ .jC)("Select", props);
  const {
    rootProps,
    placeholder,
    icon,
    color,
    height,
    h,
    minH,
    minHeight,
    iconColor,
    iconSize,
    ...rest
  } = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_3__/* .omitThemingProps */ .Lr)(props);
  const [layoutProps, otherProps] = (0,_chakra_ui_utils__WEBPACK_IMPORTED_MODULE_2__/* .split */ .Vl)(rest, _chakra_ui_system__WEBPACK_IMPORTED_MODULE_3__/* .layoutPropNames */ .oE);
  const ownProps = (0,_chakra_ui_form_control__WEBPACK_IMPORTED_MODULE_4__/* .useFormControl */ .Yp)(otherProps);
  const rootStyles = {
    width: "100%",
    height: "fit-content",
    position: "relative",
    color
  };
  const fieldStyles = _chakra_ui_utils__WEBPACK_IMPORTED_MODULE_5___default()({ paddingEnd: "2rem" }, styles.field, { _focus: { zIndex: "unset" } });
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_chakra_ui_system__WEBPACK_IMPORTED_MODULE_1__/* .chakra.div */ .m$.div, {
    className: "chakra-select__wrapper",
    __css: rootStyles,
    ...layoutProps,
    ...rootProps
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(SelectField, {
    ref,
    height: h ?? height,
    minH: minH ?? minHeight,
    placeholder,
    ...ownProps,
    __css: fieldStyles
  }, props.children), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(SelectIcon, {
    "data-disabled": (0,_chakra_ui_utils__WEBPACK_IMPORTED_MODULE_2__/* .dataAttr */ .PB)(ownProps.disabled),
    ...(iconColor || color) && { color: iconColor || color },
    __css: styles.icon,
    ...iconSize && { fontSize: iconSize }
  }, icon));
});
if (_chakra_ui_utils__WEBPACK_IMPORTED_MODULE_2__/* .__DEV__ */ .Ts) {
  Select.displayName = "Select";
}
var DefaultIcon = (props) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", {
  viewBox: "0 0 24 24",
  ...props
}, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
  fill: "currentColor",
  d: "M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z"
}));
var IconWrapper = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_1__/* .chakra */ .m$)("div", {
  baseStyle: {
    position: "absolute",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    pointerEvents: "none",
    top: "50%",
    transform: "translateY(-50%)"
  }
});
var SelectIcon = (props) => {
  const { children = /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(DefaultIcon, null), ...rest } = props;
  const clone = (0,react__WEBPACK_IMPORTED_MODULE_0__.cloneElement)(children, {
    role: "presentation",
    className: "chakra-select__icon",
    focusable: false,
    "aria-hidden": true,
    style: {
      width: "1em",
      height: "1em",
      color: "currentColor"
    }
  });
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(IconWrapper, {
    ...rest,
    className: "chakra-select__icon-wrapper"
  }, (0,react__WEBPACK_IMPORTED_MODULE_0__.isValidElement)(children) ? clone : null);
};
if (_chakra_ui_utils__WEBPACK_IMPORTED_MODULE_2__/* .__DEV__ */ .Ts) {
  SelectIcon.displayName = "SelectIcon";
}



/***/ }),

/***/ 7525:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/contato",
      function () {
        return __webpack_require__(6874);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 64:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ AlertComponent; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8641);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3038);


function AlertComponent(param) {
    var show = param.show, title = param.title, status = param.status, description = param.description;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: show && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Flex */ .kC, {
            position: "fixed",
            top: "0",
            bottom: "0",
            left: "0",
            right: "0",
            justifyContent: "center",
            alignItems: "center",
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            zIndex: "9999",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Alert */ .bZ, {
                status: status,
                variant: "subtle",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                textAlign: "center",
                height: "200px",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .AlertIcon */ .zM, {
                        boxSize: "40px",
                        mr: 0
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .AlertTitle */ .Cd, {
                        mt: 4,
                        mb: 1,
                        fontSize: "lg",
                        children: title
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .AlertDescription */ .X, {
                        maxWidth: "sm",
                        children: description
                    })
                ]
            })
        })
    });
};


/***/ }),

/***/ 6874:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ index_page; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(7568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(6042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(9396);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(4051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react-input-mask/index.js
var react_input_mask = __webpack_require__(6627);
var react_input_mask_default = /*#__PURE__*/__webpack_require__.n(react_input_mask);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/hooks/dist/index.esm.js
var index_esm = __webpack_require__(9653);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/modal/dist/index.esm.js + 53 modules
var dist_index_esm = __webpack_require__(3387);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/button/dist/index.esm.js
var button_dist_index_esm = __webpack_require__(7741);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/form-control/dist/index.esm.js
var form_control_dist_index_esm = __webpack_require__(3234);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/input/dist/index.esm.js
var input_dist_index_esm = __webpack_require__(979);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/select/dist/index.esm.js
var select_dist_index_esm = __webpack_require__(7026);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/textarea/dist/index.esm.js
var textarea_dist_index_esm = __webpack_require__(4995);
// EXTERNAL MODULE: ./node_modules/react-hook-form/dist/index.esm.mjs
var react_hook_form_dist_index_esm = __webpack_require__(7536);
// EXTERNAL MODULE: ./services/contato.js
var contato = __webpack_require__(2994);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/icons/dist/index.esm.js
var icons_dist_index_esm = __webpack_require__(3382);
// EXTERNAL MODULE: ./components/Layout/Default/index.tsx + 1 modules
var Default = __webpack_require__(7309);
// EXTERNAL MODULE: ./components/Container/index.tsx
var Container = __webpack_require__(1344);
// EXTERNAL MODULE: ./node_modules/polished/dist/polished.esm.js + 6 modules
var polished_esm = __webpack_require__(7573);
// EXTERNAL MODULE: ./styles/stitches.config.ts
var stitches_config = __webpack_require__(4767);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/index.esm.js
var layout_dist_index_esm = __webpack_require__(8641);
// EXTERNAL MODULE: ./components/Button/index.tsx
var Button = __webpack_require__(8859);
;// CONCATENATED MODULE: ./pages/contato/styles.ts




var Map = (0,stitches_config/* styled */.zo)("div", {
    width: "100%",
    height: 200,
    marginBottom: 50,
    background: "#A7C2B9",
    "@lg": {
        height: 350,
        marginBottom: 112
    }
});
var Flex = (0,stitches_config/* styled */.zo)("div", {
    "@lg": {
        display: "flex",
        justifyContent: "space-between"
    }
});
var Left = (0,stitches_config/* styled */.zo)("div", {
    flex: 1,
    marginBottom: 50,
    "@lg": {
        marginBottom: 0
    }
});
var Form = (0,stitches_config/* styled */.zo)("form", {
    marginTop: 15,
    "@md": {
        marginTop: 32
    }
});
var Grid = (0,stitches_config/* styled */.zo)(layout_dist_index_esm/* Grid */.rj, {
    gridTemplateColumns: "repeat(1, 1fr)",
    "@md": {
        gridTemplateColumns: "repeat(2, 1fr)"
    }
});
var Right = (0,stitches_config/* styled */.zo)("aside", {
    flex: 1,
    "@lg": {
        marginLeft: 94,
        maxWidth: 400
    }
});
var styles_Button = (0,stitches_config/* styled */.zo)(Button/* default */.Z, {
    position: "relative",
    marginTop: 56,
    "& svg": {
        marginLeft: 5,
        marginTop: "-2px"
    }
});
var About = (0,stitches_config/* styled */.zo)("div", {
    padding: 16,
    borderRadius: 4,
    background: "$emerald50",
    border: "solid 1px",
    borderColor: "$emerald500",
    "@lg": {
        padding: 48
    },
    "& h4": {
        fontSize: "28px !important",
        marginBottom: 40
    }
});
var Item = (0,stitches_config/* styled */.zo)("div", {
    display: "flex",
    alignItems: "center",
    "&:not(:last-of-type)": {
        paddingBottom: 35,
        marginBottom: 35,
        borderBottom: "solid 1px",
        borderBottomColor: "$emerald500"
    }
});
var IconWrap = (0,stitches_config/* styled */.zo)("div", {
    width: 60,
    height: 60,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginRight: 10,
    borderRadius: "100%",
    background: "$emerald100"
});
var Label = (0,stitches_config/* styled */.zo)("p", {
    fontFamily: "$domine",
    fontWeight: "bold",
    fontSize: (0,polished_esm/* rem */.hO)(14),
    color: "$grey900"
});
var Text = (0,stitches_config/* styled */.zo)("p", {
    fontFamily: "$domine",
    fontSize: (0,polished_esm/* rem */.hO)(14),
    color: "$grey600",
    marginLeft: "auto"
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
// EXTERNAL MODULE: ./pages/components/Loading/index.js
var Loading = __webpack_require__(3229);
// EXTERNAL MODULE: ./pages/components/AlertComponent/index.js
var AlertComponent = __webpack_require__(64);
// EXTERNAL MODULE: ./utils/useRecaptcha.js
var useRecaptcha = __webpack_require__(9210);
;// CONCATENATED MODULE: ./pages/contato/index.page.js


















var Contato = function() {
    var ref = (0,useRecaptcha/* useRecaptcha */.Z)(), isValid = ref.isValid, reply = ref.reply, question = ref.question;
    var ref1 = (0,index_esm/* useDisclosure */.qY)(), isOpen = ref1.isOpen, onOpen = ref1.onOpen, onClose = ref1.onClose;
    var ref2 = (0,react.useState)(false), loading = ref2[0], setLoading = ref2[1];
    var ref3 = (0,react.useState)(false), error = ref3[0], setError = ref3[1];
    var ref4 = (0,react.useState)(false), success = ref4[0], setSuccess = ref4[1];
    var router = (0,next_router.useRouter)();
    var handleClose = function() {
        router.push("/comprar-grama");
        onClose();
    };
    (0,react.useEffect)(function() {
        onOpen();
    }, [
        onOpen
    ]);
    var ref5 = (0,react_hook_form_dist_index_esm/* useForm */.cI)(), register = ref5.register, handleSubmit = ref5.handleSubmit, reset = ref5.reset, getValues = ref5.getValues, errors = ref5.formState.errors;
    var onSubmit = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(data) {
            var payload;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        setLoading(true);
                        _ctx.prev = 1;
                        payload = (0,_object_spread/* default */.Z)({
                            "your-subject": data.assunto,
                            "your-email": data.email,
                            "your-name": data.nome
                        }, data);
                        _ctx.next = 5;
                        return (0,contato/* sendContact */.b8)(payload);
                    case 5:
                        setSuccess(true);
                        setError(false);
                        window === null || window === void 0 ? void 0 : window.scrollTo(0, 0);
                        reset();
                        setTimeout(function() {
                            setSuccess(false);
                        }, 5000);
                        _ctx.next = 17;
                        break;
                    case 12:
                        _ctx.prev = 12;
                        _ctx.t0 = _ctx["catch"](1);
                        setError(true);
                        setSuccess(false);
                        setTimeout(function() {
                            setError(false);
                            setSuccess(false);
                        }, 5000);
                    case 17:
                        _ctx.prev = 17;
                        setLoading(false);
                        return _ctx.finish(17);
                    case 20:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    12,
                    17,
                    20
                ]
            ]);
        }));
        return function onSubmit(data) {
            return _ref.apply(this, arguments);
        };
    }();
    var telefoneRef = register("telefone");
    var celularRef = register("celular");
    var handleTelefoneChange = function(e) {
        telefoneRef === null || telefoneRef === void 0 ? void 0 : telefoneRef.onChange(e);
    };
    var handleCelularChange = function(e) {
        celularRef === null || celularRef === void 0 ? void 0 : celularRef.onChange(e);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Default/* default */.Z, {
        category: "Contato",
        title: "Fale Conosco, conhe\xe7a nossa localiza\xe7\xe3o",
        description: "Formul\xe1rio dedicado aos clientes com d\xfavidas sobre grama, sugest\xf5es, reclama\xe7\xf5es, an\xfancios, parcerias, vagas de empregos ou assuntos relacionados...",
        keywords: "contato sobre grama, d\xfavidas sobre grama, falar sobre grama, or\xe7amento sobre grama, or\xe7amento de grama, contato para or\xe7ar grama, contato sobre pre\xe7o de grama, contato empresas de grama...",
        categorySize: "1.6rem",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Loading/* default */.Z, {
                    isLoading: loading
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(AlertComponent/* default */.Z, {
                    show: success,
                    title: "Formul\xe1rio Enviado",
                    status: "success",
                    description: "Obrigado por entrar em contato, em breve te retornaremos!"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(AlertComponent/* default */.Z, {
                    show: error,
                    title: "Oops",
                    status: "error",
                    description: "Houve um erro ao enviar, tente novamente mais tarde."
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist_index_esm/* Modal */.u_, {
                    isOpen: isOpen,
                    onClose: onClose,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* ModalOverlay */.ZA, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist_index_esm/* ModalContent */.hz, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* ModalHeader */.xB, {
                                    children: "Deseja enviar Or\xe7amento?"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* ModalCloseButton */.ol, {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist_index_esm/* ModalBody */.fe, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            children: "* N\xe3o utilize esse formul\xe1rio"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            children: "Clique no bot\xe3o abaixo"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* ModalFooter */.mz, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(button_dist_index_esm/* Button */.zx, {
                                        variant: "solid",
                                        width: "100%",
                                        colorScheme: "blue",
                                        size: "lg",
                                        onClick: handleClose,
                                        children: "Enviar or\xe7amento"
                                    })
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Map, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("iframe", {
                                src: "https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d14626.120239019925!2d-48.0304943!3d-23.5853158!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x94c5cdf58eaf1217%3A0xf3df8fe4be0cb4ec!2sCentral%20da%20Grama!5e0!3m2!1spt-BR!2sbr!4v1681262176297!5m2!1spt-BR!2sbr",
                                style: {
                                    border: 0,
                                    width: "100%",
                                    height: "100%"
                                },
                                loading: "lazy",
                                referrerPolicy: "no-referrer-when-downgrade"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Left, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                            children: "Envie uma mensagem"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Form, {
                                            onSubmit: handleSubmit(onSubmit),
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid, {
                                                    gap: "24px",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(form_control_dist_index_esm/* FormControl */.NI, {
                                                            isInvalid: errors.nome,
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(input_dist_index_esm/* Input */.II, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, register("nome", {
                                                                    required: "Este campo \xe9 obrigat\xf3rio",
                                                                    minLength: {
                                                                        value: 3,
                                                                        message: "O nome deve ter pelo menos 3 caracteres"
                                                                    }
                                                                })), {
                                                                    type: "text",
                                                                    placeholder: "Nome"
                                                                })),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(form_control_dist_index_esm/* FormErrorMessage */.J1, {
                                                                    children: errors.nome && errors.nome.message
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(form_control_dist_index_esm/* FormControl */.NI, {
                                                            isInvalid: errors.assunto,
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(select_dist_index_esm/* Select */.Ph, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, register("assunto", {
                                                                    required: "Este campo \xe9 obrigat\xf3rio"
                                                                })), {
                                                                    placeholder: "Assunto",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                                            value: "D\xfavidas",
                                                                            children: "D\xfavidas"
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                                            value: "Reclama\xe7\xf5es",
                                                                            children: "Reclama\xe7\xf5es"
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                                            value: "Sugest\xf5es",
                                                                            children: "Sugest\xf5es"
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                                            value: "An\xfancios",
                                                                            children: "An\xfancios"
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                                            value: "Parcerias",
                                                                            children: "Parcerias"
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                                            value: "Vagas de Empregos",
                                                                            children: "Vagas de Empregos"
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                                            value: "Outros",
                                                                            children: "Outros"
                                                                        })
                                                                    ]
                                                                })),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(form_control_dist_index_esm/* FormErrorMessage */.J1, {
                                                                    children: errors.assunto && errors.assunto.message
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(form_control_dist_index_esm/* FormControl */.NI, {
                                                            isInvalid: errors.email,
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(input_dist_index_esm/* Input */.II, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, register("email", {
                                                                    required: "Este campo \xe9 obrigat\xf3rio",
                                                                    pattern: {
                                                                        value: /\S+@\S+\.\S+/,
                                                                        message: "Digite um email v\xe1lido"
                                                                    }
                                                                })), {
                                                                    type: "email",
                                                                    placeholder: "Email"
                                                                })),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(form_control_dist_index_esm/* FormErrorMessage */.J1, {
                                                                    children: errors.email && errors.email.message
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(form_control_dist_index_esm/* FormControl */.NI, {
                                                            isInvalid: errors.confirmarEmail,
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(input_dist_index_esm/* Input */.II, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, register("confirmarEmail", {
                                                                    validate: function(value) {
                                                                        return value === getValues("email") || "Os emails n\xe3o correspondem";
                                                                    }
                                                                })), {
                                                                    type: "email",
                                                                    placeholder: "Confirme seu email"
                                                                })),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(form_control_dist_index_esm/* FormErrorMessage */.J1, {
                                                                    children: errors.confirmarEmail && errors.confirmarEmail.message
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(form_control_dist_index_esm/* FormControl */.NI, {
                                                            isInvalid: errors.telefone,
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)((react_input_mask_default()), (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                                                    mask: "(99) 9999-9999",
                                                                    maskChar: "",
                                                                    onChange: handleTelefoneChange,
                                                                    value: telefoneRef.value
                                                                }, register("telefone", {
                                                                    required: "Este campo \xe9 obrigat\xf3rio"
                                                                })), {
                                                                    children: function() {
                                                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(input_dist_index_esm/* Input */.II, {
                                                                            type: "tel",
                                                                            placeholder: "Telefone",
                                                                            name: "telefone"
                                                                        });
                                                                    }
                                                                })),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(form_control_dist_index_esm/* FormErrorMessage */.J1, {
                                                                    children: errors.telefone && errors.telefone.message
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(form_control_dist_index_esm/* FormControl */.NI, {
                                                            isInvalid: errors.celular,
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)((react_input_mask_default()), (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                                                    mask: "(99) 9 9999-9999",
                                                                    maskChar: "",
                                                                    onChange: handleCelularChange,
                                                                    value: celularRef.value
                                                                }, register("celular", {
                                                                    required: "Este campo \xe9 obrigat\xf3rio"
                                                                })), {
                                                                    children: function() {
                                                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(input_dist_index_esm/* Input */.II, {
                                                                            type: "tel",
                                                                            placeholder: "Celular",
                                                                            name: "celular"
                                                                        });
                                                                    }
                                                                })),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(form_control_dist_index_esm/* FormErrorMessage */.J1, {
                                                                    children: errors.celular && errors.celular.message
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(form_control_dist_index_esm/* FormControl */.NI, {
                                                    isInvalid: errors.mensagem,
                                                    mt: "24px",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(textarea_dist_index_esm/* Textarea */.g, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, register("mensagem", {
                                                            required: "Este campo \xe9 obrigat\xf3rio"
                                                        })), {
                                                            placeholder: "Mensagem",
                                                            resize: "none"
                                                        })),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(form_control_dist_index_esm/* FormErrorMessage */.J1, {
                                                            children: errors.mensagem && errors.mensagem.message
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(form_control_dist_index_esm/* FormControl */.NI, {
                                                    mt: "24px",
                                                    isInvalid: !isValid(),
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(form_control_dist_index_esm/* FormLabel */.lX, {
                                                            children: question
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(input_dist_index_esm/* Input */.II, {
                                                            type: "text",
                                                            placeholder: "Digite aqui a resposta",
                                                            onChange: function(event) {
                                                                return reply(event.target.value);
                                                            }
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(form_control_dist_index_esm/* FormErrorMessage */.J1, {
                                                            children: "Por favor, responda a quest\xe3o acima."
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles_Button, {
                                                    disabled: !isValid() || loading,
                                                    shape: "rounded",
                                                    children: [
                                                        "Enviar mensagem ",
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_dist_index_esm/* ArrowForwardIcon */.mr, {
                                                            w: 4,
                                                            h: 4
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Right, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(About, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                                children: "Contate-nos"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Item, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(IconWrap, {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                                                            width: "26",
                                                            height: "34",
                                                            viewBox: "0 0 26 34",
                                                            fill: "none",
                                                            xmlns: "http://www.w3.org/2000/svg",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                                    d: "M13.0019 19.3437C11.8432 19.3437 10.7105 19.0001 9.74709 18.3564C8.78367 17.7126 8.03278 16.7977 7.58937 15.7272C7.14596 14.6567 7.02994 13.4788 7.25599 12.3423C7.48204 11.2059 8.04 10.162 8.85932 9.34271C9.67864 8.52339 10.7225 7.96543 11.8589 7.73938C12.9954 7.51333 14.1733 7.62934 15.2438 8.07276C16.3143 8.51617 17.2292 9.26706 17.873 10.2305C18.5167 11.1939 18.8603 12.3266 18.8603 13.4852C18.8584 15.0384 18.2406 16.5275 17.1424 17.6257C16.0441 18.724 14.5551 19.3418 13.0019 19.3437ZM13.0019 9.97019C12.3067 9.97019 11.627 10.1763 11.049 10.5626C10.471 10.9488 10.0204 11.4978 9.75437 12.1401C9.48832 12.7824 9.41871 13.4891 9.55434 14.171C9.68997 14.8529 10.0247 15.4792 10.5163 15.9708C11.0079 16.4624 11.6343 16.7971 12.3161 16.9328C12.998 17.0684 13.7047 16.9988 14.347 16.7327C14.9893 16.4667 15.5383 16.0162 15.9245 15.4381C16.3108 14.8601 16.5169 14.1805 16.5169 13.4852C16.516 12.5533 16.1454 11.6598 15.4864 11.0008C14.8274 10.3418 13.9338 9.97112 13.0019 9.97019Z",
                                                                    fill: "#10B981"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                                    d: "M13.0019 33.4039L3.1175 21.7468C2.98016 21.5718 2.84424 21.3956 2.70976 21.2184C1.02133 18.9943 0.109202 16.2776 0.113295 13.4852C0.113295 10.067 1.47119 6.78873 3.88827 4.37165C6.30535 1.95458 9.5836 0.59668 13.0019 0.59668C16.4201 0.59668 19.6984 1.95458 22.1155 4.37165C24.5325 6.78873 25.8904 10.067 25.8904 13.4852C25.8945 16.2764 24.9828 18.9918 23.2951 21.2149L23.294 21.2184C23.294 21.2184 22.9425 21.68 22.8897 21.7421L13.0019 33.4039ZM4.57977 19.8065C4.58211 19.8065 4.85395 20.1674 4.91605 20.2447L13.0019 29.7811L21.0982 20.2318C21.1498 20.1674 21.424 19.8042 21.4251 19.803C22.8044 17.9858 23.5498 15.7666 23.5471 13.4852C23.5471 10.6885 22.436 8.00628 20.4584 6.02867C18.4808 4.05106 15.7986 2.94006 13.0019 2.94006C10.2051 2.94006 7.52289 4.05106 5.54529 6.02867C3.56768 8.00628 2.45667 10.6885 2.45667 13.4852C2.45421 15.768 3.19926 17.9885 4.57977 19.8065Z",
                                                                    fill: "#10B981"
                                                                })
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Label, {
                                                        children: "Localiza\xe7\xe3o"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text, {
                                                        children: "Itapetininga/SP"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Item, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(IconWrap, {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                                            width: "20",
                                                            height: "30",
                                                            viewBox: "0 0 20 30",
                                                            fill: "none",
                                                            xmlns: "http://www.w3.org/2000/svg",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                                d: "M15.4531 0H4.54403C2.2804 0 0.453125 1.82727 0.453125 4.09091V25.9091C0.453125 28.1727 2.2804 30 4.54403 30H15.4531C17.7168 30 19.544 28.1727 19.544 25.9091V4.09091C19.544 1.82727 17.7168 0 15.4531 0ZM16.8168 23.1818H3.1804V4.09091H16.8168V23.1818ZM12.7259 27.2727H7.27131V25.9091H12.7259V27.2727Z",
                                                                fill: "#10B981"
                                                            })
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Label, {
                                                        children: "Telefone"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text, {
                                                        children: "(11) 9 9617-2172"
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var index_page = (Contato);


/***/ }),

/***/ 9419:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Y8": function() { return /* binding */ apiSameOrigin; },
/* harmony export */   "fz": function() { return /* binding */ apiContact; },
/* harmony export */   "hi": function() { return /* binding */ api; },
/* harmony export */   "rY": function() { return /* binding */ apiAcf; }
/* harmony export */ });
/* unused harmony export apiCg */
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9669);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(axios__WEBPACK_IMPORTED_MODULE_0__);

var api = axios__WEBPACK_IMPORTED_MODULE_0___default().create({
    baseURL: "https://admin.centraldagrama.com/wp-json/wp/v2",
    auth: {
        password: "XL(y^JmUcTolp0$Snz5WCN1i",
        username: "versatilnow"
    }
});
var apiContact = axios__WEBPACK_IMPORTED_MODULE_0___default().create({
    baseURL: "https://admin.centraldagrama.com/wp-json/contact-form-7/v1/contact-forms",
    headers: {
        "Content-Type": "multipart/form-data"
    },
    auth: {
        password: "XL(y^JmUcTolp0$Snz5WCN1i",
        username: "versatilnow"
    }
});
var apiSameOrigin = axios__WEBPACK_IMPORTED_MODULE_0___default().create({
    baseURL: "/api"
});
var apiAcf = axios__WEBPACK_IMPORTED_MODULE_0___default().create({
    baseURL: "https://admin.centraldagrama.com/wp-json/acf/v3",
    auth: {
        password: "XL(y^JmUcTolp0$Snz5WCN1i",
        username: "versatilnow"
    }
});
var apiCg = axios__WEBPACK_IMPORTED_MODULE_0___default().create({
    baseURL: "https://admin.centraldagrama.com/wp-json/central-da-grama/v1",
    auth: {
        password: "XL(y^JmUcTolp0$Snz5WCN1i",
        username: "versatilnow"
    },
    headers: {
        "Content-Type": "application/json"
    }
});


/***/ }),

/***/ 2994:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "FO": function() { return /* binding */ sendBudget; },
/* harmony export */   "b8": function() { return /* binding */ sendContact; },
/* harmony export */   "gO": function() { return /* binding */ sendOrder; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7568);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4051);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var services_api__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9419);



var sendContact = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(payload) {
        var data;
        return _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return services_api__WEBPACK_IMPORTED_MODULE_1__/* .apiContact.post */ .fz.post("501/feedback", payload);
                case 2:
                    data = _ctx.sent.data;
                    return _ctx.abrupt("return", data);
                case 4:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function sendContact(payload) {
        return _ref.apply(this, arguments);
    };
}();
var sendBudget = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(payload) {
        var data;
        return _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return services_api__WEBPACK_IMPORTED_MODULE_1__/* .apiContact.post */ .fz.post("573/feedback", payload);
                case 2:
                    data = _ctx.sent.data;
                    return _ctx.abrupt("return", data);
                case 4:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function sendBudget(payload) {
        return _ref.apply(this, arguments);
    };
}();
var sendOrder = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(payload) {
        var data;
        return _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return services_api__WEBPACK_IMPORTED_MODULE_1__/* .apiSameOrigin.post */ .Y8.post("/send-mail", payload);
                case 2:
                    data = _ctx.sent.data;
                    return _ctx.abrupt("return", data);
                case 4:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function sendOrder(payload) {
        return _ref.apply(this, arguments);
    };
}();


/***/ }),

/***/ 9210:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useRecaptcha; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);

var useRecaptcha = function() {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(), rightResponse = ref[0], setRightResponse = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(), question = ref1[0], setQuestion = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(), response = ref2[0], setResponse = ref2[1];
    var isValid = function() {
        return rightResponse === response;
    };
    var generateQuestion = function() {
        var a = Math.floor(Math.random() * 101);
        var b = Math.floor(Math.random() * 101);
        setRightResponse(Number(a + b));
        setQuestion("Qual \xe9 o valor da soma ".concat(a, " + ").concat(b, "?"));
    };
    var reply = function(value) {
        var parsedValue = Number(value);
        setResponse(parsedValue);
    };
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        generateQuestion();
    }, []);
    return {
        question: question,
        isValid: isValid,
        reply: reply,
        generateQuestion: generateQuestion
    };
};


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [753,921,305,112,434,774,888,179], function() { return __webpack_exec__(7525); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);